import { ListingStatus as n, RoninOrderStatus as a } from "../../constants/listingInfo.js";
import { CurrencyTokenType as d } from "../../../currency-lib/constants/currency.js";
import { currencyTokenTypeSchema as u } from "../../../currency-lib/deserialize/yup/currency.js";
import * as r from "ramda";
import * as e from "yup";
const c = e.mixed().oneOf(Object.values(n)).default(n.UNLISTING), l = e.mixed().oneOf(Object.values(a)).default(a.Expired), i = e.object({
  kind: e.number().default(0),
  orderKindEnum: e.string().default(""),
  asset: e.object({
    erc: e.number().default(1),
    addr: e.string().default(""),
    id: e.string().default(""),
    quantity: e.string().default("")
  }).default(null),
  expiredAt: e.date().default(null),
  paymentToken: e.string().default(""),
  startedAt: e.date().default(null),
  basePrice: e.string().default(""),
  endedAt: e.date().default(null),
  endedPrice: e.string().default(""),
  expectedState: e.string().default(""),
  nonce: e.number().default(0),
  marketFeePercentage: e.number().default(0),
  signature: e.string().default(""),
  orderStatus: l
}), m = e.object({
  currencyType: u.default(d.Ron),
  duration: e.number().default(0),
  endPrice: e.number().default(0),
  startDate: e.date().default(null),
  startPrice: e.number().default(0),
  roninSaleOrder: i.default(null)
}).from("currencyCode", "currencyType"), p = e.object({
  currencyType: u,
  duration: e.number().default(0),
  endPrice: e.number().default(0),
  index: e.number().default(0),
  quantity: e.number().default(0),
  startDate: e.date().default(null),
  startPrice: e.number().default(0),
  roninSaleOrder: i
}).when(["$data"], (t) => e.object().transform(() => ({
  duration: r.pathOr(0, ["listingInfo", "duration"], t),
  endPrice: r.pathOr(0, ["listingInfo", "endPrice"], t),
  index: r.propOr(0, "listingIndex", t),
  quantity: r.propOr(0, "qty", t),
  startDate: r.pathOr(0, ["listingInfo", "startDate"], t),
  startPrice: r.pathOr(0, ["listingInfo", "startPrice"], t),
  roninSaleOrder: r.pathOr(null, ["listingInfo", "roninSaleOrder"], t)
})));
export {
  p as listingInfoForNFT1155Schema,
  m as listingInfoSchema,
  c as listingStatusSchema,
  i as roninSaleOrderSchema
};
//# sourceMappingURL=listingInfo.js.map
